import { render } from "./DetectedDimensions.vue?vue&type=template&id=ee97aeb0&scoped=true"
import script from "./DetectedDimensions.vue?vue&type=script&lang=js"
export * from "./DetectedDimensions.vue?vue&type=script&lang=js"

import "./DetectedDimensions.vue?vue&type=style&index=0&id=ee97aeb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee97aeb0"]])

export default __exports__